/**
 * Load Facebook Kit 
 **/
app.add({
    init: function(app){
        (function(d, s, id) {
          var js, fjs = d.getElementsByTagName(s)[0];
          if (d.getElementById(id)) return;
          js = d.createElement(s); js.id = id;
          js.src = "//connect.facebook.net/en_US/sdk.js#xfbml=1&version=v2.5";
          fjs.parentNode.insertBefore(js, fjs);
        }(document, 'script', 'facebook-jssdk'));
    },

    onFallacyDetailedUpdate: function(){
        try{
            FB.XFBML.parse(); 
        }catch(ex){}
    }
});















// WEBPACK FOOTER //
// ./resources/assets/js/modules/facebook-like.js